import React, {Component} from 'react';
import {campusApi} from '../api'
import _ from 'lodash';
import axios from 'axios';

export default class PingCampusPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error_message: null,
      current_campus_url: window.location.origin,
      campuses: []
    }

    this.renderCampusRow = this.renderCampusRow.bind(this);
    this.pingCampus = this.pingCampus.bind(this);
  }
  
  componentDidMount() {
    const { current_campus_url } = this.state;
    const { campus_name } = this.props;

    var self = this;
    campusApi.get('/campus_data').then(function (response) {
      let campuses = response.data;
      self.setState({campuses: campuses}, function(){
        this.pingCampus();
      });
    });
  }

  pingCampus(){
    const self = this;
    let {campuses} = this.state;
    
    _.forEach(campuses, function(campus) {
      axios.get(`${campus.url}/ping`)
      .then(res => {
        let target_campus = _.find(campuses, { 'code': campus.code });
        target_campus.status = res.status

        self.setState({campuses: campuses});
      }).catch(function (error) {
        let target_campus = _.find(campuses, { 'code': campus.code });
        target_campus.status = 502

        self.setState({campuses: campuses});
      });
    });

    setTimeout(() => {
      this.pingCampus();
    }, 10000);
  }

  renderCampusRow(campus){
    return(
      <tr key={`campus-row-${campus.id}`}>
        <td>
          {campus.name}
        </td>
        <td>
          <a href={campus.url} target="_blank">{campus.url}</a>
        </td>
        <td>
          { campus.status === 200 ? (
            <span className="badge badge-success" style={{width: "60px"}}>OK</span>
          ) : (
            <span className="badge badge-danger" style={{width: "60px"}}>{campus.status}</span>
          )}
        </td>
      </tr>
    )
  }

  render(){
    return (
      <div id='ping-campus-page' className="m-3 m-md-0">
        <table className="table table-stripe">
          <tbody>
            {_.map(this.state.campuses, this.renderCampusRow)}
          </tbody>
         </table>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/PingCampusPage.js